import { ResponseAggregationValues } from '@/models/item.models';

export type EntityResponseBase = {
  id: string;
  dateAdded: string;
  dateUpdated: string;
};

export type ApiResponseBase<T> = {
  data: T;
  devstrideCorrelationId?: string;
};

export type NullResponse = ApiResponseBase<null>;

export type GenericDeleteResponse = {
  success: boolean;
};

export type ApiListResponseBase<T> = {
  data: Array<T>;
  devstrideCorrelationId?: string;
  meta: {
    cursor?: string;
    hasMoreData: boolean;
    aggregations?: ResponseAggregationValues;
    total?: number;
  };
};

export type PaginatedQueryBase = {
  limit?: number;
  cursor?: string;
  direction?: 'asc' | 'desc';
};

export interface EditorTextValueObject {
  html: string;
}
export type Primitives = string | number | boolean;

export type ISODateString = string;

export type DateTimeRange = {
  from: ISODateString;
  to: ISODateString;
};

export type DateTimeRangeOption = {
  id: string;
  label: string;
  value: DateTimeRange;
  displayRange: string;
  isDone?: boolean;
  onClick?: () => void;
};

export enum ForbiddenUploadFileTypes {
  JAVASCRIPT = 'text/javascript',
  CSS = 'text/css',
  HTML = 'text/html',
}

export type InputVariable = {
  label: string;
  name: string;
  reference: string;
  overrideText?: string;
};

// https://app.gleap.io/projects/624dcd6d00ec5a00373568d0/settings/feedbackactions
export enum GleapFlows {
  BUG_REPORTING = 'bugreporting',
  CRASH = 'crash',
  RATING = 'rating',
  CONTACT = 'contact',
  FEATURE_REQUEST = 'featurerequests',
  INQUIRY = '8ysus', // custom
}

export enum WEEKDAYS {
  SUNDAY = 'Su',
  MONDAY = 'Mo',
  TUESDAY = 'Tu',
  WEDNESDAY = 'We',
  THURSDAY = 'Th',
  FRIDAY = 'Fr',
  SATURDAY = 'Sa',
}

export type BaseOperators =
  | 'equal'
  | 'notEqual'
  | 'in'
  | 'notSet'
  | 'isSet'
  | 'notIn'
  | 'contains'
  | 'doesNotContain'
  | 'lessThan'
  | 'lessThanInclusive'
  | 'greaterThan'
  | 'greaterThanInclusive'
  | 'divisibleBy'
  | 'pathsNotEqual'
  | 'stringContains'
  | 'stringDoesNotContain';
